(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "69a0471d48d9fcbbcc0a4c22";
              window.beaePageSetting.pageTitle = "Request a refund "; 
              window.beaePageSetting.pageType = "page";

          let js_THNN2VIJ = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-734keaojsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-734keaoj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-734keaoj');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-734keaoj: ', ex)
      };
    

      try {
        let argid = 'beae-3hs0sggyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3hs0sggy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3hs0sggy');
        args.el = args.els[0];
        ((O) => { var z;let H=(z=O.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(I=>{let E=I==null?void 0:I.getAttribute("href");I&&O.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&I.addEventListener("click",A=>{let D=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3hs0sggy: ', ex)
      };
    

      try {
        let argid = 'beae-z4zr6kjzblock-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-z4zr6kjz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-z4zr6kjz');
        args.el = args.els[0];
        ((m) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,u=m.el.querySelector("form");m.el.querySelector(".beae-btn-pr");const f=m.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),b=m.el.querySelector(".btn-lightbox-form > button");!h&&m.mode.value!=="builder"&&(m.el.querySelector(".beae-form-success-message").style="display: none"),h&&m.afterSubmitting=="redirect"&&m.redirect&&(m.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=m.redirect);const C=[];u&&u.addEventListener("submit",g=>{g.preventDefault();for(let v=0;v<f.length;v++)C.push({fieldKey:f[v].name,fieldType:f[v].type,fieldValue:f[v].value})}),b&&(b.onclick=()=>{const g=document.createElement("div");g.innerHTML=u.outerHTML||"",window.BeaePopupLibrary.createPopup(g,{layout:"center",layoutMobile:"bottom",width:"500px",id:m.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-z4zr6kjz: ', ex)
      };
    }; if (window.BEAEBASE) {js_THNN2VIJ()} else {window.BEAEPAGEJS.push(js_THNN2VIJ)} })(); 